import { generateMedia } from 'styled-media-query';
import { breakpoints } from '../theme/breakpoints.js';

const media = generateMedia(breakpoints);

export { media };
//# sourceMappingURL=media.js.map
